export default __webpack_public_path__ + "2be499144e569ba691b81e892e71bd2d.svg";